import globalAdministration from './routes'

export default [...globalAdministration] as const
